import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  reloadUserLists,
  closeAddedToWishlistToast,
  openAddToUserListOffcanvas,
  closeAddToUserListOffcanvas,
  addProductToUserList,
  closeAddedToUserListToast,
  closeUserListManagerElements,
  openAuthOffcanvasPriorToLikeProduct,
  closeAuthOffcanvasPriorToLikeProduct,
} from "@actions/userlists-actions";

export function useUserListsManager() {
  return useSelector((state) => state.userlists);
}

export function useReloadUserLists() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(reloadUserLists());
  }, [dispatch]);
}

export function useIsAddToUserListToastOpen() {
  return useSelector((state) => state.userlists.ongoingAction === "addedToWishlist");
}

export function useCloseAddedToWishlistToast() {
  const dispatch = useDispatch();

  return () => dispatch(closeAddedToWishlistToast());
}

export function useOpenAddToUserListOffcanvas() {
  const dispatch = useDispatch();

  return (product) => dispatch(openAddToUserListOffcanvas(product));
}

export function useIsAddToUserListOffcanvasOpen() {
  return useSelector((state) => state.userlists.ongoingAction === "addToUserList");
}

export function useCloseAddToUserListOffcanvas() {
  const dispatch = useDispatch();

  return () => dispatch(closeAddToUserListOffcanvas());
}

export function useAddProductToUserList() {
  const dispatch = useDispatch();

  return async (userListUuid) => await dispatch(addProductToUserList(userListUuid));
}

export function useCloseAddedToUserListToast() {
  const dispatch = useDispatch();

  return () => dispatch(closeAddedToUserListToast());
}

export function useIsAddedToUserListToastOpen() {
  return useSelector((state) => state.userlists.ongoingAction === "addedToUserList");
}

export function useCloseUserListManagerElements() {
  const dispatch = useDispatch();

  return () => dispatch(closeUserListManagerElements());
}

export function useOpenAuthOffcanvasPriorToLikeProduct() {
  const dispatch = useDispatch();

  return (product) => dispatch(openAuthOffcanvasPriorToLikeProduct(product));
}

export function useCloseAuthOffcanvasPriorToLikeProduct() {
  const dispatch = useDispatch();

  return () => dispatch(closeAuthOffcanvasPriorToLikeProduct());
}

export function useIsAuthOffcanvasPriorToLikeProductOpen() {
  return useSelector((state) => state.userlists.ongoingAction === "authUserPriorToLikeProduct");
}
